import React, { useEffect, useState } from 'react';
import { Typography } from '@mui/material';
import api from '../../../../services/api';

const FeedbackDoCliente = ({ telefone }) => {
  const [feedback, setFeedback] = useState(null);

  useEffect(() => {
    const fetch = async () => {
      const { data } = await api.get('/feedback/feedbacks');
      const feedbacksDoCliente = data.filter(f => f.cliente_telefone === telefone);
      if (feedbacksDoCliente.length > 0) {
        setFeedback(feedbacksDoCliente[0]);
      }
    };
    fetch();
  }, [telefone]);

  if (!feedback) {
    return <Typography variant="body2" color="text.secondary">Nenhum feedback disponível.</Typography>;
  }

  return (
    <>
      <Typography variant="body1" sx={{ fontWeight: 500, mb: 1 }}>
        {feedback.comentario}
      </Typography>
      <Typography variant="caption" color="text.secondary">
        Nota: {feedback.nota} ⭐ — {new Date(feedback.criado_em).toLocaleDateString()}
      </Typography>
    </>
  );
};

export default FeedbackDoCliente;
